import React from 'react';

import styled from 'styled-components';

const ErrorMessage = styled.div`
  ${(props) => props.theme.text.error};
`;

export default ErrorMessage;
